var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.searchFilter = new function() {
    var self = this;

    this.init = function() {
        if ($('#category-select').length) {
            self.initFilter();
        }
    };

    this.initFilter = function() {
        if ($('#category-select').length) {
            $('.js-select-option').click(function() {

                var target = '#' + $(this).data('value');

                $('.search-result').hide();
                $('#label-select').hide();
                $(target).show();

                if (target == '#alle') {
                    $('.search-result').show();
                }
                //.each(function (e) {
                //    var sgn = $(this).attr('search-group-name');

                //    if (target == undefined || target === '' || target === sgn) {
                //        $(this).show();
                //    } else {
                //        $(this).hide();
                //    }
                //});
            });
        }
    };
};